import styled from '@emotion/styled';

import { MEDIA_QUERY, SPACING } from '../../../../../styles/emotion';
import FormInput from '../../../../Form/inputV3/FinalFormInput';

export const Container = styled.div``;

export const ChannelList = styled.ul<{ inModal?: boolean }>`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-flow: column;
  flex-wrap: wrap;
  ${MEDIA_QUERY.NOT_MOBILE} {
    max-height: 408px;
  }
`;

export const StyledInput = styled(FormInput)`
  margin-bottom: ${SPACING.S16};
`;

export const ChannelOption = styled.li`
  margin-bottom: ${SPACING.S16};
  width: 100%;
  display: flex;
  align-items: center;

  ${MEDIA_QUERY.NOT_MOBILE} {
    width: 50%;
  }
`;
